import { useLayoutEffect } from "react";
import { SITE_ORIGIN, organizationJsonLd } from "@/lib/seo";

const SCHEMA_ID = "seo-jsonld";

function upsertMeta(attr, key, content) {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function upsertLink(rel, href) {
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.rel = rel;
        document.head.appendChild(el);
    }
    el.href = href;
}

export default function Seo({ title, description, path }) {
    useLayoutEffect(() => {
        const url = `${SITE_ORIGIN}${path === "/" ? "/" : path}`;
        document.title = title;
        upsertMeta("name", "description", description);
        upsertLink("canonical", url);
        upsertMeta("property", "og:title", title);
        upsertMeta("property", "og:description", description);
        upsertMeta("property", "og:url", url);
        upsertMeta("property", "og:type", "website");
        upsertMeta("property", "og:site_name", "SalesCan");
        upsertMeta("property", "og:locale", "en_CA");
        upsertMeta("property", "og:image", `${SITE_ORIGIN}/logo.png`);
        upsertMeta("name", "twitter:card", "summary");
        upsertMeta("name", "twitter:title", title);
        upsertMeta("name", "twitter:description", description);

        const existing = document.getElementById(SCHEMA_ID);
        if (path !== "/") {
            existing?.remove();
            return;
        }
        const script = existing || document.createElement("script");
        script.id = SCHEMA_ID;
        script.type = "application/ld+json";
        script.textContent = JSON.stringify(organizationJsonLd);
        if (!existing) document.head.appendChild(script);
    }, [title, description, path]);

    return null;
}
